// @ts-nocheck
/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
/* Starter Custom Code - End */

interface OwnProps {
    title: string;
    wishListId: string;
    testSelector: string;
}

type Props = OwnProps;

const MyListsDetailsPageTypeLink: React.FunctionComponent<Props> = ({ title, wishListId, testSelector }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            testSelector,
            pageType: "MyListsDetailsPage",
            overrideTitle: title,
            queryString: `id=${wishListId}`,
            linkAccessibleText: translate("See List Details"), // Starter Custom Code
        },
    });
};

export default MyListsDetailsPageTypeLink;
